<div class="card-container p-3" style="background: #ffffff; border: 1px solid #e2e8f0; border-radius: 0.5rem; width: 100% !important;">
  <!-- Income Section -->
  <ng-container *ngIf="IncomeModel?.length">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <span class="font-weight-bold text-uppercase text-success" style="font-size: 0.8125rem; letter-spacing: 0.5px;">
        <i class="fas fa-plus-circle mr-1"></i> Income Details
      </span>
    </div>

    <div class="table-responsive rounded border mb-3" style="border-color: #e2e8f0 !important; width: 100% !important; max-height: none !important; overflow-x: auto !important; overflow-y: visible !important;">
      <table class="table table-hover table-striped mb-0 foir-table" style="font-size: 0.8125rem; width: 100% !important;">
        <thead style="background-color: var(--theme-primary, #123c53) !important; color: #ffffff !important; -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important;">
          <tr>
            <th class="py-2" style="background-color: var(--theme-primary, #123c53) !important; color: #ffffff !important; text-align: left !important;">Customer Name</th>
            <th class="py-2" style="background-color: var(--theme-primary, #123c53) !important; color: #ffffff !important; text-align: left !important;">Income Type</th>
            <th class="py-2" style="background-color: var(--theme-primary, #123c53) !important; color: #ffffff !important; text-align: left !important;">Remarks</th>
            <th class="py-2 text-right" style="background-color: var(--theme-primary, #123c53) !important; color: #ffffff !important; text-align: right !important; width: 130px;">Amount</th>
            <th class="py-2 text-right" style="background-color: var(--theme-primary, #123c53) !important; color: #ffffff !important; text-align: right !important; width: 130px;">Considered</th>
            <th class="py-2 text-center" style="background-color: var(--theme-primary, #123c53) !important; color: #ffffff !important; text-align: center !important; width: 100px;">Attachment</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of IncomeModel">
            <td class="font-weight-bold text-dark text-left">{{ row.CustomerName }}</td>
            <td class="text-left">{{ row.Inc_and_Exp_Type }}</td>
            <td class="text-muted small text-left">{{ row.Remarks }}</td>
            <td class="text-right font-weight-bold text-dark" style="text-align: right !important;">₹{{ row.Amount }}</td>
            <td class="text-right font-weight-bold text-success" style="text-align: right !important;">₹{{ row.FOIR_Amount }}</td>
            <td class="text-center" style="text-align: center !important;">
              <a *ngIf="row.Doc_FileName" target="_blank" href="{{ docBaseUrl }}{{ row.CustomerId }}/{{ row.Doc_FileName }}" class="btn btn-sm btn-outline-primary py-0 px-2 font-size-11">
                <i class="fas fa-eye"></i>
              </a>
            </td>
          </tr>
          <tr class="font-weight-bold bg-light total-row">
            <td colspan="3" class="text-right uppercase small" style="text-align: right !important;">Total Income:</td>
            <td class="text-right text-dark" style="text-align: right !important;">₹{{ totalMonthlyIncomeCalculated?.total }}</td>
            <td class="text-right text-success" style="text-align: right !important;">₹{{ totalCalculator?.total }}</td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

  <!-- Expense Section -->
  <ng-container *ngIf="ExpenseModel?.length">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <span class="font-weight-bold text-uppercase text-danger" style="font-size: 0.8125rem; letter-spacing: 0.5px;">
        <i class="fas fa-minus-circle mr-1"></i> Expense Details
      </span>
    </div>

    <div class="table-responsive rounded border mb-3" style="border-color: #e2e8f0 !important; width: 100% !important; max-height: none !important; overflow-x: auto !important; overflow-y: visible !important;">
      <table class="table table-hover table-striped mb-0 foir-table" style="font-size: 0.8125rem; width: 100% !important;">
        <thead style="background-color: var(--theme-primary, #123c53) !important; color: #ffffff !important; -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important;">
          <tr>
            <th class="py-2" style="background-color: var(--theme-primary, #123c53) !important; color: #ffffff !important; text-align: left !important;">Customer Name</th>
            <th class="py-2" style="background-color: var(--theme-primary, #123c53) !important; color: #ffffff !important; text-align: left !important;">Expense Type</th>
            <th class="py-2" style="background-color: var(--theme-primary, #123c53) !important; color: #ffffff !important; text-align: left !important;">Remarks</th>
            <th class="py-2 text-right" style="background-color: var(--theme-primary, #123c53) !important; color: #ffffff !important; text-align: right !important; width: 130px;">Amount</th>
            <th class="py-2 text-right" style="background-color: var(--theme-primary, #123c53) !important; color: #ffffff !important; text-align: right !important; width: 130px;">Considered</th>
            <th class="py-2 text-center" style="background-color: var(--theme-primary, #123c53) !important; color: #ffffff !important; text-align: center !important; width: 100px;">Attachment</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of ExpenseModel">
            <td class="font-weight-bold text-dark text-left">{{ row.CustomerName }}</td>
            <td class="text-left">{{ row.Inc_and_Exp_Type }}</td>
            <td class="text-muted small text-left">{{ row.Remarks }}</td>
            <td class="text-right font-weight-bold text-dark" style="text-align: right !important;">₹{{ row.Amount }}</td>
            <td class="text-right font-weight-bold text-danger" style="text-align: right !important;">₹{{ row.FOIR_Amount }}</td>
            <td class="text-center" style="text-align: center !important;">
              <a *ngIf="row.Doc_FileName" target="_blank" href="{{ docBaseUrl }}{{ row.CustomerId }}/{{ row.Doc_FileName }}" class="btn btn-sm btn-outline-primary py-0 px-2 font-size-11">
                <i class="fas fa-eye"></i>
              </a>
            </td>
          </tr>
          <tr class="font-weight-bold bg-light total-row">
            <td colspan="3" class="text-right uppercase small" style="text-align: right !important;">Total Expenses:</td>
            <td class="text-right text-dark" style="text-align: right !important;">₹{{ totalMonthlyExpenseCalculated?.total }}</td>
            <td class="text-right text-danger" style="text-align: right !important;">₹{{ totalCalculator1?.expAmount }}</td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

  <!-- Obligation Section -->
  <ng-container *ngIf="ObligationModel?.length">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <span class="font-weight-bold text-uppercase text-warning" style="font-size: 0.8125rem; letter-spacing: 0.5px;">
        <i class="fas fa-file-invoice-dollar mr-1"></i> Obligation Details
      </span>
    </div>

    <div class="table-responsive rounded border mb-3" style="border-color: #e2e8f0 !important; width: 100% !important; max-height: none !important; overflow-x: auto !important; overflow-y: visible !important;">
      <table class="table table-hover table-striped mb-0 foir-table" style="font-size: 0.8125rem; width: 100% !important;">
        <thead style="background-color: var(--theme-primary, #123c53) !important; color: #ffffff !important; -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important;">
          <tr>
            <th class="py-2" style="background-color: var(--theme-primary, #123c53) !important; color: #ffffff !important; text-align: left !important;">Customer Name</th>
            <th class="py-2" style="background-color: var(--theme-primary, #123c53) !important; color: #ffffff !important; text-align: left !important;">Type</th>
            <th class="py-2" style="background-color: var(--theme-primary, #123c53) !important; color: #ffffff !important; text-align: left !important;">From</th>
            <th class="py-2 text-right" style="background-color: var(--theme-primary, #123c53) !important; color: #ffffff !important; text-align: right !important; width: 130px;">Obligation</th>
            <th class="py-2 text-right" style="background-color: var(--theme-primary, #123c53) !important; color: #ffffff !important; text-align: right !important; width: 130px;">Considered</th>
            <th class="py-2" style="background-color: var(--theme-primary, #123c53) !important; color: #ffffff !important; text-align: left !important;">Remarks</th>
            <th class="py-2 text-center" style="background-color: var(--theme-primary, #123c53) !important; color: #ffffff !important; text-align: center !important; width: 80px;">Doc</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of ObligationModel">
            <td class="font-weight-bold text-dark text-left">{{ row.CustomerName }}</td>
            <td class="text-left">{{ row.Type }}</td>
            <td class="text-left">{{ row.Inc_and_Exp_From }}</td>
            <td class="text-right font-weight-bold text-dark" style="text-align: right !important;">₹{{ row.Amount }}</td>
            <td class="text-right font-weight-bold text-warning" style="text-align: right !important;">₹{{ row.FOIR_Amount }}</td>
            <td class="text-muted small text-left">{{ row.Remarks }}</td>
            <td class="text-center" style="text-align: center !important;">
              <a *ngIf="row.Doc_FileName" target="_blank" href="{{ docBaseUrl }}{{ row.CustomerId }}/{{ row.Doc_FileName }}" class="btn btn-sm btn-outline-primary py-0 px-2 font-size-11">
                <i class="fas fa-eye"></i>
              </a>
            </td>
          </tr>
          <tr class="font-weight-bold bg-light total-row">
            <td colspan="3" class="text-right uppercase small" style="text-align: right !important;">Total Obligations:</td>
            <td class="text-right text-dark" style="text-align: right !important;">₹{{ totalMonthlyObligationCalculated?.total }}</td>
            <td class="text-right text-warning" style="text-align: right !important;">₹{{ totalCalculatorObligation?.total }}</td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

  <!-- Ratio Analysis Section -->
  <div class="d-flex justify-content-between align-items-center mb-2">
    <span class="font-weight-bold text-uppercase text-primary" style="font-size: 0.8125rem; letter-spacing: 0.5px;">
      <i class="fas fa-calculator mr-1"></i> Ratio Analysis & FOIR Calculation
    </span>
  </div>

  <div class="table-responsive rounded border" style="border-color: #e2e8f0 !important; width: 100% !important; max-height: none !important; overflow-x: auto !important; overflow-y: visible !important;">
    <table class="table table-bordered mb-0" style="font-size: 0.8125rem; width: 100% !important;">
      <thead style="background-color: var(--theme-primary, #123c53) !important; color: #ffffff !important; -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important;">
        <tr>
          <th colspan="2" class="text-center py-2 text-uppercase" style="background-color: var(--theme-primary, #123c53) !important; color: #ffffff !important; -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important;">Expenses To Income Ratio</th>
          <th colspan="2" class="text-center py-2 text-uppercase" style="background-color: var(--theme-primary, #123c53) !important; color: #ffffff !important; -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important;">Obligation To Gross Ratio</th>
          <th colspan="2" class="text-center py-2 text-uppercase" style="background-color: var(--theme-primary, #123c53) !important; color: #ffffff !important; -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important;">Fixed Obligation to Income Ratio (FOIR)</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="text-muted">Gross Income</td>
          <td class="font-weight-bold text-right">₹{{ totalCalculator?.total }}</td>
          <td class="text-muted">Gross Income</td>
          <td class="font-weight-bold text-right">₹{{ totalCalculator?.total }}</td>
          <td class="text-muted">Net Income</td>
          <td class="font-weight-bold text-right">₹{{ totalCalculator?.total - totalCalculator1?.expAmount }}</td>
        </tr>
        <tr>
          <td class="text-muted">Gross Expenses</td>
          <td class="font-weight-bold text-right">₹{{ totalCalculator1?.expAmount }}</td>
          <td class="text-muted">Previous Obligation</td>
          <td class="font-weight-bold text-right">₹{{ totalCalculatorObligation?.total }}</td>
          <td class="text-muted">Previous Obligation</td>
          <td class="font-weight-bold text-right">₹{{ totalCalculatorObligation?.total }}</td>
        </tr>
        <tr>
          <td class="text-muted">Net Income</td>
          <td class="font-weight-bold text-right">₹{{ totalCalculator?.total - totalCalculator1?.expAmount }}</td>
          <td class="text-muted">Current Obligation</td>
          <td class="font-weight-bold text-right">₹{{ CurrentEmi }}</td>
          <td class="text-muted">Current Obligation</td>
          <td class="font-weight-bold text-right">₹{{ CurrentEmi }}</td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td class="font-weight-bold text-muted">Margin</td>
          <td class="font-weight-bold text-right text-info">₹{{ totalCalculator?.total - totalCalculatorObligation?.total - CurrentEmi }}</td>
          <td class="font-weight-bold text-muted">Margin</td>
          <td class="font-weight-bold text-right text-info">₹{{ totalCalculator?.total - totalCalculator1?.expAmount - totalCalculatorObligation?.total - CurrentEmi }}</td>
        </tr>
        <tr class="font-weight-bold" style="background: color-mix(in srgb, var(--theme-primary, #123c53) 12%, #ffffff);">
          <td class="text-uppercase">Expense Ratio</td>
          <td class="text-right text-primary" style="font-size: 0.9375rem;">{{ getPercentage() }} %</td>
          <td class="text-uppercase">Obligation Ratio</td>
          <td class="text-right text-warning" style="font-size: 0.9375rem;">{{ getObligationPercentage() }} %</td>
          <td class="text-uppercase text-danger">FOIR %</td>
          <td class="text-right text-danger" style="font-size: 1rem;">{{ getAdjustedObligationPercentage() }} %</td>
        </tr>
      </tbody>
    </table>
  </div>

</div>